// extracted by mini-css-extract-plugin
export default {"game":"Game_game__wUvcC","title":"Game_title__Q-pGJ"};